import Picker from './Picker'
import {PickPending} from './PickPending'

import bindResources from '../../../../shared_components/BindToStores'
import Container from '../../../../lib/Container'
import BulkInviteActions from '../../actions/BulkInviteActions'
import LegacyLoader from '../../../../shared_components/LegacyLoader'

export class PickDraft extends PickPending {
  advisor() { return (this.props.advisorSeats.find(seat => seat.advisor_seat_id.toString() === this.props.params.advisorSeatId) || {}) }
  render() {
    return (
      <LegacyLoader loading={this.props.loadingDraftClients}>
        <div className='preheader'>INVITE DRAFT CLIENTS</div>
        <h2 className='select-bulk-clients-header'>Select Clients</h2>
        <p className='select-bulk-clients-intro'>
          Below are the clients of <strong>{this.advisor().name}</strong> who are in draft status. Please select which
          ones you would like to invite to Everplans.
        </p>
        <Picker
          advisor={this.advisor()}
          clients={this.props.draft_clients}
          closer={this.props.closer}
          next={this.props.next}
          firmConfig={this.props.firmConfig}
          organization={this.props.organization}
        />
      </LegacyLoader>
    )
  }
}

Container.registerAction('draft_clients', BulkInviteActions)
export default bindResources(PickDraft, {id: 'advisorSeatId', name: 'draft_clients', type: 'item'})

PickDraft.defaultProps = {
  advisorSeats: [],
  draft_clients: {
    data: []
  }
}
